/**
 * @fileoverview gRPC-Web generated client stub for no.jotta.openapi.comment.v2
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.22.5
// source: no/jotta/openapi/comment/v2/comment.v2.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var no_jotta_openapi_ping_pb = require('../../../../../no/jotta/openapi/ping_pb.js')

var no_jotta_openapi_avatar_pb = require('../../../../../no/jotta/openapi/avatar_pb.js')

var google_api_annotations_pb = require('../../../../../google/api/annotations_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.no = {};
proto.no.jotta = {};
proto.no.jotta.openapi = {};
proto.no.jotta.openapi.comment = {};
proto.no.jotta.openapi.comment.v2 = require('./comment.v2_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.AddCommentRequest,
 *   !proto.no.jotta.openapi.comment.v2.AddCommentResponse>}
 */
const methodDescriptor_CommentServiceAuth_AddComment = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceAuth/AddComment',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.AddCommentRequest,
  proto.no.jotta.openapi.comment.v2.AddCommentResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.AddCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.AddCommentResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.AddCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.AddCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.AddCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthClient.prototype.addComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/AddComment',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_AddComment,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.AddCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.AddCommentResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthPromiseClient.prototype.addComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/AddComment',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_AddComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.UpdateCommentRequest,
 *   !proto.no.jotta.openapi.comment.v2.UpdateCommentResponse>}
 */
const methodDescriptor_CommentServiceAuth_UpdateComment = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceAuth/UpdateComment',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.UpdateCommentRequest,
  proto.no.jotta.openapi.comment.v2.UpdateCommentResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.UpdateCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.UpdateCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthClient.prototype.updateComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/UpdateComment',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_UpdateComment,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.UpdateCommentResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthPromiseClient.prototype.updateComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/UpdateComment',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_UpdateComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.DeleteCommentRequest,
 *   !proto.no.jotta.openapi.comment.v2.DeleteCommentResponse>}
 */
const methodDescriptor_CommentServiceAuth_DeleteComment = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceAuth/DeleteComment',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.DeleteCommentRequest,
  proto.no.jotta.openapi.comment.v2.DeleteCommentResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.DeleteCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.DeleteCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.DeleteCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthClient.prototype.deleteComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/DeleteComment',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_DeleteComment,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.DeleteCommentResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthPromiseClient.prototype.deleteComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/DeleteComment',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_DeleteComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.AddReplyRequest,
 *   !proto.no.jotta.openapi.comment.v2.AddReplyResponse>}
 */
const methodDescriptor_CommentServiceAuth_AddReply = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceAuth/AddReply',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.AddReplyRequest,
  proto.no.jotta.openapi.comment.v2.AddReplyResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.AddReplyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.AddReplyResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.AddReplyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.AddReplyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.AddReplyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthClient.prototype.addReply =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/AddReply',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_AddReply,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.AddReplyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.AddReplyResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthPromiseClient.prototype.addReply =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/AddReply',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_AddReply);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.UpdateReplyRequest,
 *   !proto.no.jotta.openapi.comment.v2.UpdateReplyResponse>}
 */
const methodDescriptor_CommentServiceAuth_UpdateReply = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceAuth/UpdateReply',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.UpdateReplyRequest,
  proto.no.jotta.openapi.comment.v2.UpdateReplyResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.UpdateReplyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.UpdateReplyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthClient.prototype.updateReply =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/UpdateReply',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_UpdateReply,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.UpdateReplyResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthPromiseClient.prototype.updateReply =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/UpdateReply',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_UpdateReply);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.DeleteReplyRequest,
 *   !proto.no.jotta.openapi.comment.v2.DeleteReplyResponse>}
 */
const methodDescriptor_CommentServiceAuth_DeleteReply = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceAuth/DeleteReply',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.DeleteReplyRequest,
  proto.no.jotta.openapi.comment.v2.DeleteReplyResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.DeleteReplyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteReplyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.DeleteReplyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.DeleteReplyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthClient.prototype.deleteReply =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/DeleteReply',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_DeleteReply,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteReplyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.DeleteReplyResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthPromiseClient.prototype.deleteReply =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/DeleteReply',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_DeleteReply);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.PingRequest,
 *   !proto.no.jotta.openapi.PingResponse>}
 */
const methodDescriptor_CommentServiceAuth_Ping = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceAuth/Ping',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_ping_pb.PingRequest,
  no_jotta_openapi_ping_pb.PingResponse,
  /**
   * @param {!proto.no.jotta.openapi.PingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_ping_pb.PingResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.PingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.PingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/Ping',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_Ping,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.PingResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceAuthPromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceAuth/Ping',
      request,
      metadata || {},
      methodDescriptor_CommentServiceAuth_Ping);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.GetCommentsRequest,
 *   !proto.no.jotta.openapi.comment.v2.GetCommentsResponse>}
 */
const methodDescriptor_CommentServiceNonAuth_GetComments = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetComments',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.GetCommentsRequest,
  proto.no.jotta.openapi.comment.v2.GetCommentsResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.GetCommentsResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.GetCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.GetCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthClient.prototype.getComments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetComments',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetComments,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.GetCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthPromiseClient.prototype.getComments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetComments',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetComments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.GetCommentsRequest,
 *   !proto.no.jotta.openapi.comment.v2.GetCommentsResponse>}
 */
const methodDescriptor_CommentServiceNonAuth_GetAggregatedComments = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetAggregatedComments',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.GetCommentsRequest,
  proto.no.jotta.openapi.comment.v2.GetCommentsResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.GetCommentsResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.GetCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.GetCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthClient.prototype.getAggregatedComments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetAggregatedComments',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetAggregatedComments,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.GetCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthPromiseClient.prototype.getAggregatedComments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetAggregatedComments',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetAggregatedComments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.GetCommentRequest,
 *   !proto.no.jotta.openapi.comment.v2.GetCommentResponse>}
 */
const methodDescriptor_CommentServiceNonAuth_GetComment = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetComment',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.GetCommentRequest,
  proto.no.jotta.openapi.comment.v2.GetCommentResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.GetCommentResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.GetCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.GetCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthClient.prototype.getComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetComment',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetComment,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.GetCommentResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthPromiseClient.prototype.getComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetComment',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.GetGroupRequest,
 *   !proto.no.jotta.openapi.comment.v2.GetGroupResponse>}
 */
const methodDescriptor_CommentServiceNonAuth_GetGroup = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetGroup',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.GetGroupRequest,
  proto.no.jotta.openapi.comment.v2.GetGroupResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.GetGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.GetGroupResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.GetGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.GetGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthClient.prototype.getGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetGroup',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetGroup,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.GetGroupResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthPromiseClient.prototype.getGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetGroup',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.GetGroupsRequest,
 *   !proto.no.jotta.openapi.comment.v2.GetGroupsResponse>}
 */
const methodDescriptor_CommentServiceNonAuth_GetGroups = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetGroups',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.GetGroupsRequest,
  proto.no.jotta.openapi.comment.v2.GetGroupsResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.GetGroupsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.GetGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.GetGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.GetGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthClient.prototype.getGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetGroups',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetGroups,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.GetGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthPromiseClient.prototype.getGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetGroups',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetGroups);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.GetRepliesRequest,
 *   !proto.no.jotta.openapi.comment.v2.GetRepliesResponse>}
 */
const methodDescriptor_CommentServiceNonAuth_GetReplies = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetReplies',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.GetRepliesRequest,
  proto.no.jotta.openapi.comment.v2.GetRepliesResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.GetRepliesResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.GetRepliesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.GetRepliesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthClient.prototype.getReplies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetReplies',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetReplies,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.GetRepliesResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthPromiseClient.prototype.getReplies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetReplies',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetReplies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest,
 *   !proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse>}
 */
const methodDescriptor_CommentServiceNonAuth_GetGroupCommentCount = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetGroupCommentCount',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest,
  proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse,
  /**
   * @param {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthClient.prototype.getGroupCommentCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetGroupCommentCount',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetGroupCommentCount,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthPromiseClient.prototype.getGroupCommentCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/GetGroupCommentCount',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_GetGroupCommentCount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.PingRequest,
 *   !proto.no.jotta.openapi.PingResponse>}
 */
const methodDescriptor_CommentServiceNonAuth_Ping = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/Ping',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_ping_pb.PingRequest,
  no_jotta_openapi_ping_pb.PingResponse,
  /**
   * @param {!proto.no.jotta.openapi.PingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_ping_pb.PingResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.PingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.PingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/Ping',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_Ping,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.PingResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.comment.v2.CommentServiceNonAuthPromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.comment.v2.CommentServiceNonAuth/Ping',
      request,
      metadata || {},
      methodDescriptor_CommentServiceNonAuth_Ping);
};


module.exports = proto.no.jotta.openapi.comment.v2;

